export const isValidEnum = <T extends string[]>(
  enumObj: T,
  value: string | null | undefined
): T[number] => {
  if (!value || !Object.values(enumObj).includes(value)) {
    throw new Error(`Invalid enum value: ${value}`);
  }
  return value;
};
